import { useAppSelector } from 'app/store';
import { ROLE_TENANT_TECHNICIAN_COORDINATOR } from './../../constants';

export function isTechnicianCoordinator(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_TECHNICIAN_COORDINATOR) ?? false;
}
